import { connect } from 'react-redux'
import { compose } from 'recompose'

import Component from './component'

export default compose(connect())(Component)
